<template>
  <div>
	  <div class="row">
		  <div class="col-lg-12">
			  <h1 class="page-header">Druckvorlagen</h1>
		  </div>
	  </div>

	  <custom-table edit="/template/{:id}" add="/template/new" src="/api/templates/" search="search" :cols="cols"></custom-table>
  </div>
</template>

<script>
import CustomTable from './../components/custom-table.vue'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
  beforeRouteEnter (to, from, next) {
    const route = authCheck('templates')
    if (route === null) {
      next()
    } else {
      next(route)
    }
  },

	data () {
		return {
			cols: [
				{ 'name': 'Vorname', 'json': 'firstname', 'type': 'text' },
				{ 'name': 'Nachname', 'json': 'lastname', 'type': 'text' },
				{ 'name': 'Geburtstag', 'json': 'birthday', 'type': 'date' },
				{ 'name': 'Todestag', 'json': 'dyingday', 'type': 'date' },
				{ 'name': 'Beisetzung', 'json': 'burial', 'type': 'date' }
			]
		}
	},
	components: {
		'custom-table': CustomTable
	}
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// TemplateOverview.vue?0f024075